import styled from 'styled-components'

const TabbedRadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`

const TabbedRadioLabel = styled.label`
    display: inline-block;
    background-color: ${props => props.isActive ? 'black' : '#ededed'};
    position: relative; 
    padding: 10px 25px;
    margin-right: 20px;
    margin-bottom: 10px;
    
    input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
    
    input + span {
      font-weight: bold;
    }

    input[type="radio"]:checked + span {
      color: ${props => props.isActive ? 'white' : 'black'};
    }
`

const TabbedRadio = ({options, activeTabId, name, handleChange}) => {
  return <TabbedRadioWrapper>
    {options.map((option, i) =>
      <TabbedRadioLabel for={option.label} isActive={activeTabId === option.value}>
        <input
          type="radio"
          id={option.id}
          name={name}
          value={option.value}
          checked={activeTabId === option.value}
          onChange={() => handleChange(i)}
        />
        <span>{option.label}</span>
      </TabbedRadioLabel>
    )}
  </TabbedRadioWrapper>
}

export default TabbedRadio